export const defaultJson = [
  {
    stepId: 'personalDetails',
    stepName: 'Personal Details',
    showStepName: false,
    stepVisible: true,
    stepPosition: 0,
    stepType: 'form',
    sections: [
      {
        apiKeyId: 'application',
        sectionId: 'identity',
        sectionName: 'Identity',
        subSectionName: '',
        sectionPosition: 1,
        sectionType: 'form',
        sectionHelp: 'Fields marked with * are required',
        fields: [
          {
            fieldId: 'applicant[Aadhaar_Number__c]',
            required: true,
            name: 'applicant[Aadhaar_Number__c]',
            label: 'Aadhaar Number',
            type: 'input',
            validationType: 'aadhaar',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid 12 digit Aadhaar number',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Blood_Group__c]',
            required: true,
            name: 'applicant[Blood_Group__c]',
            label: 'Blood Group',
            type: 'select',
            metaData: {
              optionsKey: 'bloodGroups',
            },
            options: [],
            validations: {
              required: 'Please select your blood group',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[APAAR_ID__c]',
            required: true,
            name: 'applicant[APAAR_ID__c]',
            label: 'Automated Permanent Academic Account Registry (APAAR ID)',
            type: 'input',
            validationType: 'apaarId',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid APAAR ID',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Name_as_per_degree_certificate__c]',
            required: true,
            name: 'applicant[Name_as_per_degree_certificate__c]',
            label: 'Name as per Degree Certificate',
            type: 'input',
            validationType: 'alphaWithSpace',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Provide the name as it appears in all your previous academic records',
              },
              maxLength: {
                value: 100,
                message: 'This field cannot be more than 100 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'passport',
        sectionName: 'Passport',
        subSectionName: '',
        sectionPosition: 2,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'applicant[Passport_Number__c]',
            required: true,
            name: 'applicant[Passport_Number__c]',
            label: 'Passport Number',
            type: 'input',
            validationType: 'alphaNumeric',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Applicant_Type__c]',
                expectedValue: 'International',
                type: 'LEAF',
              },
            },
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid passport number',
              },
              minLength: {
                value: 6,
                message: 'This field cannot be less than 6 characters',
              },
              maxLength: {
                value: 15,
                message: 'This field cannot be more than 15 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Passport_Expiry_Date__c]',
            required: true,
            name: 'applicant[Passport_Expiry_Date__c]',
            label: 'Passport Validity',
            type: 'date',
            minDate: true,
            format: 'YYYY-MM-DD',
            maxDate: 15,
            validations: {
              required: 'Please select the passport validity date',
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Applicant_Type__c]',
                expectedValue: 'International',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Passport_place_of_issue__c]',
            required: true,
            name: 'applicant[Passport_place_of_issue__c]',
            label: 'Place of Issue',
            type: 'input',
            validationType: 'passportPlace',
            validations: {
              required: 'Please enter the passport place of issue',
              maxLength: {
                value: 128,
                message: 'This field cannot be greater than 128 characters',
              },
              pattern: {
                value: '',
                message: 'Please enter a valid value',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Applicant_Type__c]',
                expectedValue: 'International',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Passport_Number__c]',
            name: 'applicant[Passport_Number__c]',
            label: 'Passport Number',
            type: 'input',
            validationType: 'alphaNumeric',
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Applicant_Type__c]',
                expectedValue: 'Domestic',
                type: 'LEAF',
              },
            },
            validations: {
              pattern: {
                value: '',
                message: 'Please enter a valid passport number',
              },
              minLength: {
                value: 6,
                message: 'This field cannot be less than 6 characters',
              },
              maxLength: {
                value: 15,
                message: 'This field cannot be more than 15 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Passport_Expiry_Date__c]',
            name: 'applicant[Passport_Expiry_Date__c]',
            label: 'Passport Validity',
            type: 'date',
            minDate: true,
            format: 'YYYY-MM-DD',
            maxDate: 15,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Applicant_Type__c]',
                expectedValue: 'Domestic',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Passport_place_of_issue__c]',
            name: 'applicant[Passport_place_of_issue__c]',
            label: 'Place of Issue',
            type: 'input',
            validationType: 'passportPlace',
            validations: {
              maxLength: {
                value: 128,
                message: 'This field cannot be greater than 128 characters',
              },
              pattern: {
                value: '',
                message: 'Please enter a valid value',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'application[Applicant_Type__c]',
                expectedValue: 'Domestic',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'disability',
        sectionName: 'Disability',
        subSectionName: '',
        sectionPosition: 1,
        sectionType: 'form',
        sectionHelp: 'Fields marked with * are required',
        fields: [
          {
            fieldId: 'applicant[Disability_Support_Required__c]',
            required: true,
            name: 'applicant[Disability_Support_Required__c]',
            label: 'Disability Support Required?',
            type: 'radio',
            options: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            validations: {
              required: 'Please select an option',
            },
            ui: {
              gridType: 'fullRow',
            },
          },
          {
            fieldId: 'applicant[Institute_Should_know_About_Disability__c]',
            required: true,
            name: 'applicant[Institute_Should_know_About_Disability__c]',
            label: 'Is there anything the Institute should know about your disability or condition that would aid us in meeting your needs, including use of assistive equipment or technology ?',
            type: 'textArea',
            rows: 4,
            validations: {
              required: 'Please provide the required details',
              maxLength: {
                value: 500,
                message: 'This field cannot be graeter than 500 characters',
              },
            },
            maxCharacters: 500,
            remaining: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'applicant[Disability_Support_Required__c]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            ui: {
              gridType: 'fullRow',
            },
          },
          {
            fieldId: 'applicant[Any_aids_that_you_use__c]',
            required: true,
            name: 'applicant[Any_aids_that_you_use__c]',
            label: 'Any aids / appliances / assistive technology that you use ?',
            type: 'textArea',
            rows: 4,
            validations: {
              required: 'Please provide the required details',
              maxLength: {
                value: 500,
                message: 'This field cannot be graeter than 500 characters',
              },
            },
            maxCharacters: 500,
            remaining: true,
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'applicant[Disability_Support_Required__c]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            ui: {
              gridType: 'fullRow',
            },
          },
          {
            fieldId: 'applicant[Accommodation_Requirements__c]',
            required: true,
            name: 'applicant[Accommodation_Requirements__c]',
            label: 'Please share the academic accommodations you require this year and if any support you have used in your previous academic journey',
            type: 'textArea',
            rows: 4,
            validations: {
              required: 'Please specify the academic accommodations required',
              maxLength: {
                value: 500,
                message: 'This field cannot be graeter than 500 characters',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'applicant[Disability_Support_Required__c]',
                expectedValue: 'Yes',
                type: 'LEAF',
              },
            },
            maxCharacters: 500,
            remaining: true,
            ui: {
              gridType: 'fullRow',
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'medical',
        sectionName: 'Medical',
        subSectionName: '',
        sectionPosition: 2,
        sectionType: 'form',
        fields: [
          {
            fieldId: 'applicant[Medical_Condition_Details__c]',
            required: true,
            name: 'applicant[Medical_Condition_Details__c]',
            label: 'If you have any medical condition, please share relevant details including medication, emergencies, and required support',
            type: 'textArea',
            validations: {
              required: 'Please provide details of any medical condition',
              maxLength: {
                value: 500,
                message: 'This field cannot be greater than 500 characters',
              },
            },
            maxCharacters: 500,
            remaining: true,
            ui: {
              gridType: 'fullRow',
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'familyDetails',
        sectionName: 'Father Details',
        subSectionName: '',
        sectionPosition: 1,
        sectionType: 'form',
        sectionHelp: 'Fields marked with * are required',
        fields: [
          {
            fieldId: 'applicationRelation[0][Name__c]',
            required: true,
            name: 'applicationRelation[0][Name__c]',
            label: 'Name',
            type: 'input',
            validationType: 'fullName',
            validations: {
              required: "Please enter father's name",
              pattern: {
                value: '',
                message: 'Please enter a valid name',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[0][Phone__c]',
            required: false,
            name: 'applicationRelation[0][Phone__c]',
            label: 'Phone Number',
            type: 'phone',
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[0][Email__c]',
            required: false,
            name: 'applicationRelation[0][Email__c]',
            label: 'Email Id',
            type: 'input',
            validationType: 'email',
            validations: {
              pattern: {
                value: '',
                message: 'Please enter a valid email ID',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[0][Occupation__c]',
            required: false,
            name: 'applicationRelation[0][Occupation__c]',
            label: 'Occupation',
            type: 'input',
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'familyDetails',
        sectionName: 'Mother Details',
        subSectionName: '',
        sectionPosition: 1,
        sectionType: 'form',
        sectionHelp: 'Fields marked with * are required',
        fields: [
          {
            fieldId: 'applicationRelation[1][Name__c]',
            required: true,
            name: 'applicationRelation[1][Name__c]',
            label: 'Name',
            type: 'input',
            validationType: 'fullName',
            validations: {
              required: "Please enter mother's name",
              pattern: {
                value: '',
                message: 'Please enter a valid name',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[1][Phone__c]',
            required: false,
            name: 'applicationRelation[1][Phone__c]',
            label: 'Phone Number',
            type: 'phone',
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[1][Email__c]',
            required: false,
            name: 'applicationRelation[1][Email__c]',
            label: 'Email Id',
            type: 'input',
            validationType: 'email',
            validations: {
              pattern: {
                value: '',
                message: 'Please enter a valid email ID',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[1][Occupation__c]',
            required: false,
            name: 'applicationRelation[1][Occupation__c]',
            label: 'Occupation',
            type: 'input',
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'bankDetails',
        sectionName: 'Bank Details',
        subSectionName: '',
        sectionPosition: 1,
        sectionType: 'form',
        sectionHelp: 'Fields marked with * are required',
        fields: [
          {
            fieldId: 'applicant[Bank_Account_Number__c]',
            required: true,
            name: 'applicant[Bank_Account_Number__c]',
            label: 'Bank Account Number',
            type: 'input',
            validationType: 'number',
            validations: {
              required: 'This field is required',
              minLength: {
                value: 8,
                message: 'Please enter a valid bank account number',
              },
              maxLength: {
                value: 18,
                message: 'Please enter a valid bank account number',
              },
              pattern: {
                value: '',
                message: 'Please enter a valid bank account number',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[IFSC__c]',
            required: true,
            name: 'applicant[IFSC__c]',
            label: 'IFSC',
            type: 'input',
            validationType: 'ifscandswift',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid IFS code',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Account_Holder_Name__c]',
            required: true,
            name: 'applicant[Account_Holder_Name__c]',
            label: 'Account Holder Name',
            type: 'input',
            validationType: 'fullName',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter account holder name',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Bank_Account_Type__c]',
            required: true,
            name: 'applicant[Bank_Account_Type__c]',
            label: 'Account Type',
            type: 'select',
            options: [
              {
                label: 'Savings',
                value: 'Savings',
              },
              {
                label: 'Current',
                value: 'Current',
              },
            ],
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Bank_Name__c]',
            required: true,
            name: 'applicant[Bank_Name__c]',
            label: 'Bank Name',
            type: 'input',
            validationType: 'fullName',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter bank name',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'addressDetails',
        sectionName: 'Emergency Address Details',
        subSectionName: '',
        sectionPosition: 1,
        sectionType: 'form',
        sectionHelp: 'Fields marked with * are required',
        fields: [
          {
            fieldId: 'applicationRelation[2][Name__c]',
            required: true,
            name: 'applicationRelation[2][Name__c]',
            label: 'Emergency Contact Person Name',
            type: 'input',
            validationType: 'fullName',
            validations: {
              required: 'Please enter emergency contact person name',
              pattern: {
                value: '',
                message: 'Please enter a valid name',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[2][Relationship_Type__c]',
            required: true,
            name: 'applicationRelation[2][Relationship_Type__c]',
            label: 'Relationship',
            type: 'select',
            options: [],
            metaData: {
              optionsKey: 'applicantRelation',
            },
            validations: {
              required: 'Please select relationship',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[2][Relationship_Type_Other__c]',
            required: true,
            name: 'applicationRelation[2][Relationship_Type_Other__c]',
            label: 'Other Relationship',
            type: 'input',
            validationType: 'fullName',
            validations: {
              required: 'This field is required',
              pattern: {
                value: '',
                message: 'Please enter a valid relationship',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'applicationRelation[2][Relationship_Type__c]',
                expectedValue: 'Other',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[2][Phone__c]',
            required: true,
            name: 'applicationRelation[2][Phone__c]',
            label: 'Emergency Contact Mobile',
            type: 'phone',
            validations: {
              required: 'Please enter a valid mobile number',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicationRelation[2][Email__c]',
            required: false,
            name: 'applicationRelation[2][Email__c]',
            label: 'Emergency Contact Email Address',
            type: 'input',
            validationType: 'email',
            validations: {
              pattern: {
                value: '',
                message: 'Please enter a valid email ID',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            name: 'addresses[2]',
            type: 'address',
            options: [
              {
                fieldId: 'hed__MailingCountry__c',
                required: true,
                name: 'hed__MailingCountry__c',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'hed__MailingState__c',
                required: true,
                name: 'hed__MailingState__c',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'hed__MailingCity__c',
                required: true,
                name: 'hed__MailingCity__c',
                label: 'District',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
            ],
          },
          {
            fieldId: 'addresses[2][Address_Line_1__c]',
            required: true,
            name: 'addresses[2][Address_Line_1__c]',
            label: 'Town/City',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 255,
                message: 'This field cannot be greater than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[2][Address_Line_2__c]',
            name: 'addresses[2][Address_Line_2__c]',
            label: 'Emergency Address Line',
            type: 'input',
            required: true,
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 255,
                message: 'This field cannot be greater than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[2][hed__MailingPostalCode__c]',
            required: true,
            name: 'addresses[2][hed__MailingPostalCode__c]',
            label: 'Pincode/Zipcode',
            type: 'input',
            validationType: 'number',
            helperText: '',
            validations: {
              required: 'This field is required',
              minLength: {
                value: 6,
                message: 'Please enter a valid Zipcode',
              },
              maxLength: {
                value: 6,
                message: 'Please enter a valid Zipcode',
              },
              pattern: {
                value: '',
                message: 'Please enter a valid Zipcode',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'addresses[2][hed__MailingCountry__c]',
                expectedValue: 'India',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[2][hed__MailingPostalCode__c]',
            required: true,
            name: 'addresses[2][hed__MailingPostalCode__c]',
            label: 'Pincode/Zipcode',
            type: 'input',
            validationType: 'pincode',
            helperText: '',
            validations: {
              required: 'This field is required',
              minLength: {
                value: 4,
                message: 'This field cannot be less than 4 characters',
              },
              maxLength: {
                value: 10,
                message: 'This field cannot be more than 10 characters',
              },
              pattern: {
                value: '',
                message: 'Please enter a valid Zipcode',
              },
            },
            rule: {
              effect: 'HIDE',
              condition: {
                scope: 'addresses[2][hed__MailingCountry__c]',
                expectedValue: 'India',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'addressDetails',
        sectionName: 'Current Address',
        subSectionName: '',
        sectionPosition: 1,
        sectionType: 'form',
        sectionHelp: 'Fields marked with * are required',
        fields: [
          {
            name: 'addresses[0]',
            type: 'address',
            options: [
              {
                fieldId: 'hed__MailingCountry__c',
                required: true,
                name: 'hed__MailingCountry__c',
                isPartOfCollection: true,
                label: 'Country',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'hed__MailingState__c',
                required: true,
                name: 'hed__MailingState__c',
                label: 'State',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
              {
                fieldId: 'hed__MailingCity__c',
                required: true,
                name: 'hed__MailingCity__c',
                label: 'District',
                type: 'select',
                validations: {
                  required: 'This field is required',
                },
                options: [],
                ui: {
                  grid: {
                    xs: 12,
                    md: 6,
                    lg: 4,
                  },
                },
              },
            ],
          },
          {
            fieldId: 'addresses[0][Address_Line_1__c]',
            required: true,
            name: 'addresses[0][Address_Line_1__c]',
            label: 'Town/City',
            type: 'input',
            validations: {
              required: 'This field is required',
              maxLength: {
                value: 254,
                message: 'This field cannot be more than 254 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[0][Address_Line_2__c]',
            name: 'addresses[0][Address_Line_2__c]',
            label: 'Address Line',
            type: 'input',
            validations: {
              maxLength: {
                value: 255,
                message: 'This field cannot be greater than 255 characters',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[0][hed__MailingPostalCode__c]',
            required: true,
            name: 'addresses[0][hed__MailingPostalCode__c]',
            label: 'Pincode/Zipcode',
            type: 'input',
            validationType: 'number',
            helperText: '',
            validations: {
              required: 'This field is required',
              minLength: {
                value: 6,
                message: 'Please enter a valid Zipcode',
              },
              maxLength: {
                value: 6,
                message: 'Please enter a valid Zipcode',
              },
              pattern: {
                value: '',
                message: 'Please enter a valid Zipcode',
              },
            },
            rule: {
              effect: 'SHOW',
              condition: {
                scope: 'addresses[0][hed__MailingCountry__c]',
                expectedValue: 'India',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'addresses[0][hed__MailingPostalCode__c]',
            required: true,
            name: 'addresses[0][hed__MailingPostalCode__c]',
            label: 'Pincode/Zipcode',
            type: 'input',
            validationType: 'pincode',
            helperText: '',
            validations: {
              required: 'This field is required',
              minLength: {
                value: 4,
                message: 'This field cannot be less than 4 characters',
              },
              maxLength: {
                value: 10,
                message: 'This field cannot be more than 10 characters',
              },
              pattern: {
                value: '',
                message: 'Please enter a valid Zipcode',
              },
            },
            rule: {
              effect: 'HIDE',
              condition: {
                scope: 'addresses[0][hed__MailingCountry__c]',
                expectedValue: 'India',
                type: 'LEAF',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
      {
        apiKeyId: 'application',
        sectionId: 'additionalInfo',
        sectionName: 'Additional Info',
        subSectionName: '',
        sectionPosition: 1,
        sectionType: 'form',
        sectionHelp: 'Fields marked with * are required',
        fields: [
          {
            fieldId: 'applicant[hed__Religion__c]',
            required: true,
            name: 'applicant[hed__Religion__c]',
            label: 'Religion',
            type: 'select',
            options: [],
            metaData: {
              optionsKey: 'preEnrollmentReligion',
            },
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Domicile__c]',
            required: true,
            name: 'applicant[Domicile__c]',
            label: 'Domicile',
            type: 'select',
            options: [],
            metaData: {
              valueKey: 'addresses[0][hed__MailingCountry__c]',
            },
            validations: {
              required: 'This field is required',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Mother_Tongue__c]',
            required: true,
            name: 'applicant[Mother_Tongue__c]',
            label: 'Mother Tongue',
            type: 'select',
            options: [],
            metaData: {
              optionsKey: 'language',
            },
            validations: {
              required: 'Please select mother tongue',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[Annual_Family_Income_from_all_sources__c]',
            required: true,
            name: 'applicant[Annual_Family_Income_from_all_sources__c]',
            label: 'Annual Family Income (from all sources)',
            type: 'select',
            options: [],
            metaData: {
              optionsKey: 'annualFamilyIncome',
              avoidSorting: true,
            },
            validations: {
              required: 'Please select annual family income',
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
          {
            fieldId: 'applicant[No_of_Dependents__c]',
            required: true,
            name: 'applicant[No_of_Dependents__c]',
            label: 'No. of Dependents',
            type: 'input',
            validationType: 'number',
            validations: {
              required: 'Please enter number of dependents',
              pattern: {
                value: '',
                message: 'Please enter a proper value',
              },
            },
            ui: {
              grid: {
                xs: 12,
                md: 6,
                lg: 4,
              },
            },
          },
        ],
      },
    ],
  },
  {
    stepId: 'documents',
    stepName: 'Documents',
    showStepName: false,
    stepVisible: true,
    stepPosition: 6,
    stepType: 'documentUpload',
  },
  {
    stepId: 'declaration',
    stepName: 'Declaration',
    showStepName: false,
    stepVisible: true,
    stepPosition: 6,
    stepType: 'declaration',
  },
];
